<template>
    <div class="user-manager">
        <div class="slider-left">
            <nav-slider :active='thisActive'></nav-slider>
        </div>
        <div class="content">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/homePage' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item >账号管理</el-breadcrumb-item>
            </el-breadcrumb>
            <div v-if="false">你还没有管理员账号 ，无法进行当前操作  <el-button style="margin-left:20px" type="primary" size='small'>立即创建</el-button>  </div>
            <div v-else>
                <div class="userList">
                <div class="title-wrap">
                    <h3 class="title">
                        员工列表
                        <el-button @click="toAddUser" type="primary">新增员工</el-button>    
                    </h3>
                </div>
                <div class="search-box">
                    角色: <el-select v-model="searchRole" placeholder="请选择">
                        <el-option
                        v-for="item in roles"
                        :key="item.value"
                        :label="item.value"
                        :value="item.value">
                        </el-option>
                    </el-select>
                    用户名: <el-input  placeholder="请输入关键字"></el-input>
                    用户名: <el-input  placeholder="请输入关键字"></el-input>
                    状态: <el-select v-model="searchUserStatus" placeholder="请选择">
                        <el-option
                        v-for="item in userStatus"
                        :key="item.value"
                        :label="item.value"
                        :value="item.value">
                        </el-option>
                    </el-select>
                    <el-button  type="primary">搜索</el-button>    
                </div>
            </div>
            <el-table
            :data="userList"
            style="width: 100%">
            <el-table-column
                prop="id"
                label="序号">
            </el-table-column>
            <el-table-column
                prop="name"
                label="姓名">
            </el-table-column>
            <el-table-column
                label="角色">
                <template slot-scope="scope">
                    <p :class="'role'+scope.row.role.value">{{ scope.row.role.text }}</p>
                </template>
            </el-table-column>
            <el-table-column
                prop="uNumber"
                label="账号">
            </el-table-column>
            <el-table-column
                label="状态">
                <template slot-scope="scope">
                    <p :class="'status'+scope.row.status.value">{{ scope.row.status.text }}</p>
                </template>

            </el-table-column>
            <el-table-column
                prop="createTime"
                label="新增时间">
            </el-table-column>
            <el-table-column
                prop="wechatTel"
                label="微信手机">
            </el-table-column>
            <el-table-column
                prop="wechatName"
                label="微信昵称">
            </el-table-column>
            <el-table-column style="text-align:center"
                label="操作"
                width="250">
                <template slot-scope="scope" >
                    <el-button v-if="scope.row.status.value==0" @click="bindWechat(scope.row)" type="success" size='small'>激活</el-button>
                    <el-button v-else @click="edit(scope.row.id)" type="primary" size='small'>编辑</el-button>
                    <el-button @click="del(scope.row.id)" type="danger" size='small'>删除</el-button>
                </template>
            </el-table-column>
            </el-table>
            <el-pagination style="float:right"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageInfo.pageNum"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="pageInfo.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="pageInfo.total">
            </el-pagination>
            </div>
            
        </div>
       
    </div>
</template>

<script>
    import navSlider from '../components/slider'
    export default {
        components:{navSlider},
        data() {
            return {
                pageInfo:{
                    pageSize:10,
                    pageNum:1,
                    total:100
                },
                roles:[{
                    value:"负责人"
                },{
                    value:'管理员'
                },{
                    value:'操作员'
                },{
                    value:'财务'
                }],
                userStatus:[{
                    value:"可用"
                },{
                    value:'待激活'
                }],
                userList:[
                    {
                        id:1,
                        name:"张三",
                        role:{
                            value:0,
                            text:'管理员'
                        },
                        uNumber:'12001101400',
                        status:{
                            value:0,
                            text:'待激活'
                        },
                        createTime:'/',
                        wechatTel:'/',
                        wechatName:'/'
                    },
                    {
                        id:2,
                        name:"李四",
                        role:{
                            value:1,
                            text:"负责人"
                        },
                        uNumber:'12001101400',
                        status:{
                            value:1,
                            text:'可用'
                        },
                        createTime:'2013/11/21',
                        wechatTel:13019222222,
                        wechatName:'牛牛牛'
                   },
                   {
                        id:3,
                        name:"李四",
                        role:{
                            value:2,
                            text:'财务'
                        },
                        uNumber:'12001101400',
                        status:{
                            value:1,
                            text:'可用'
                        },
                        createTime:'2013/11/21',
                        wechatTel:13019222222,
                        wechatName:'牛牛牛'
                   },
                   {
                        id:4,
                        name:"李四",
                        role:{
                            value:3,
                            text:'操作员'
                        },
                        uNumber:'12001101400',
                        status:{
                            value:1,
                            text:'可用'
                        },
                        createTime:'2013/11/21',
                        wechatTel:13019222222,
                        wechatName:'牛牛牛'
                   },

                ],
                searchRole:'',
                searchUserStatus:'',
                thisActive:''

            }
                
        },
        methods: {
            bindWechat(item){
                console.log(item)
            },
            del(id){
                this.$confirm('是否删除序号为'+id+'的这一项', '警告', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
                }) 
            },
            edit(id){
                this.$router.push({
                    path:'/add-user?id='+id
                })
            },
            handleSizeChange(){

            },
            handleCurrentChange(){

            },
            toAddUser(){
                this.$router.push({
                    path:'/add-user'
                })
            }


            
        },
        mounted() {
            this.thisActive=this.$route.path
        },

        
    }
</script>

<style scoped lang='stylus'>

.user-manager{
    .slider-left{
        width:12%
        float left
    }
    .content{
        .el-breadcrumb{
            margin 10px 0 20px 
        }
        
        float right
        width 84%
        padding 5px
        .title-wrap{
            padding-bottom 10px
            border-bottom 1px solid rgba(232, 232, 232, 1)     
        }
        .title{
            border-left 5px solid rgba(93, 91, 91, 1)
            padding-left 10px
            .el-button{
                margin-left 20px
            }
        }     
        .search-box{
            margin 20px 0
            .el-input,.el-select{
                margin 0 20px 0 10px
                width 150px
            }
        }
        .el-table{
            margin-bottom 20px
            .role0,.role1,.role2,.role3{
                width 66px
                height 24px
                line-height 24px
                text-align center
                color white
                border-radius 4px
            }
            .role0{
                background rgba(67, 207, 124, 1)
            }
            .role1{
                background rgba(212, 48, 48, 1)
            }
            .role2{
                background rgba(255, 141, 26, 1)
            }
            .role3{
                background rgba(128, 128, 128, 1)
            }
            .status0{
                color rgba(212, 48, 48, 1)
            }
            .status1{
                color rgba(67, 207, 124, 1)
            }
            
        }
    }

}
</style>